export const deviceID = () => {
  const deviceId = localStorage.getItem('deviceID')
  if (deviceId) return deviceId
  const id = window.URL.createObjectURL(new Blob([])).split('/').pop()
  localStorage.setItem('deviceID', id as string)
  return id
}
